import { useTranslations } from 'next-intl';
import { HostLegacy } from '@silvertours/front-legacy-entities';
import { UiLegacy } from '@silvertours/front-legacy-shared';

import { Container } from './NewsletterRegistration.styles';

type NewsletterSignupSuccessProps = {
  showTitle?: boolean;
};

const NewsletterSignupSuccess = ({
  showTitle,
}: NewsletterSignupSuccessProps) => {
  const t = useTranslations(
    'features.newsletterRegistrationLegacy.newsletterRegistration',
  );
  const { formatImage } = HostLegacy.useHost();

  return (
    <>
      {showTitle && (
        <UiLegacy.SectionTitle>
          {t('newsletterSuccessTitle')}
        </UiLegacy.SectionTitle>
      )}
      <Container alignCenter>
        <img
          src={formatImage('/bm/global/graphic/image/flexsite/nl_success.svg')}
          alt=""
          width={115}
          height={132}
        />
        {t('newsletterSuccessText')}
      </Container>
    </>
  );
};

export { NewsletterSignupSuccess };
